<template>
<!-- TODO:
   - Sort importHeaders before sending to BtFilterDefiner
   - If possible, re-write this page with the new BtChart (after removing extras and adding actions).
-->
<!-- HISTORY:
   06/02/22(B1.25): Consumed BtFilterWrapperWithPanel's btHelpers and filterResult props.
   05/24/22(B1.24): Obtained behFields from bt-mixin + In eventsClicked(), changed the logic of getting events texts.
   05/05/22(B1.23): Fixed the bug with initializing filter (moved new lines to the end).
   05/04/22(B1.22): Consumed initialFilter prop and set filter to use the latest import.
   05/02/22(B1.22): Implemented logout feature.
   04/14/22(B1.21): Commented Actions header (from Aref side).
   04/01/22(B1.20): Only made indexed headers sortable.
   03/25/22(B1.19): Moved filter change from B1.13 in the getOffersCount() function of cs-api-service.js file.
   03/17/22(B1.18): Showed Delete Results btn only if the user has contact-offers-delete policy.
   03/08/22(B1.17): Disabled dialog buttons while deleting offers are in progress, and displayed elapsed time +
      Allowed deleting offers only if there is no other delete in progress.
   03/03/22(B1.16): Fixed the issue with Delete Results btn that didn't hide if no offers.
   03/03/22(B1.15): Called filterChanged() after offers were deleted successfully + Added hide-default-footer prop to v-data-table.
   03/03/22(B1.14): Implemented DELETE RESULTS functionality + Modified dialog to dialogEvents.
   02/18/22(B1.13): in getOffersCount(), modified empty filter to increase the speed of the query.
   02/17/22(B1.12): Added "# of Fields" to the end of expanded items of the offers table.
   02/03/22(B1.11): Moved the indexed settings from B1.10 into BtHelpers.getImportHeaders().
   02/01/22(B1.10): Added isIndexed property to the import fields to be used inside BtFilterDefiner + Removed some of commented codes.
   08/05/21(B1.9): Some clean-up + Removed Alert() + Set has-pagina-table for bt-chart.
   08/02/21(B1.8): Consumed bt-helpers.js and removed related methods.
   07/22/21(B1.7): Removed aid from all methods params and passed filter to getImports().
   07/13/21(B1.6): Added a dialog to display events details in an extendable table.
   07/08/21(B1.5): Added required logic (including behFieldsForGroupby) to support added event fields to the groupby fields.
   06/22/21(B1.4): Changed import_id to importId.
   06/21/21(B1.3): Added names to the import_id values + Added internalField: true property to the internal import headers.
   06/14/21(B1.2): Added import_id to the standard fields + Consumed stdFieldValues prop.
   06/08/21(B1.1): Fixed a bug that didn't persist chart values.
   06/08/21(B1.0): Consumed BtFilterWrapperWithPanel and changed the code accordingly (filterChanged() won't be triggerred 1st time) +
      Updated BtChart props.
   05/26/21(B0.15): Added Actions column to the table and Delete Results btn + Changed the page title and added icon.
   05/25/21(B0.14): Replaced v-data-table with Google table.
   05/20/21(B0.13): Consumed BtChart component.
   05/13/21(B0.12): Supported sorting of the table headers.
   05/12/21(B0.11): Supported distinct and the 2nd dropdown in the groupby tab + Fixed the bug w/displaying groupby date fields.
   05/06/21(B0.10): Fixed bug with offer details after groupby.
   05/04/21(B0.9): Added getImportIds() to pass them to BtFilterDefiner.
   04/29/21(B0.8): Removed footer for aggregate + Displayed the name of days and months.
   04/28/21(B0.7): Applied changed to support groupby.dateType.
   04/26/21(B0.6): Displayed field name instead of _id + Formatted groupby numbers.
   04/20/21(B0.5): Passed closedOnLoad prop + Fixed item-expanded bug.
   04/19/21(B0.4): Added <style> + Fixed the bug that called getOffers() with no filter + Added basePurl and purlNumber to importHeaders +
      Implemented data-table's built-in pagination + Added getOffersCount().
   04/12/21(B0.3): Set items-per-page + Called getOffers on limit change + Reduced # of init headers +
      Displayed offers details + Distinguished headers types.
   04/08/21(B0.2): Filter w/selectable columns + Added limit dropdown + Made field names lowercase.
   03/xx/21(B0.1): 1st release.
-->
<v-container fluid class="px-3 py-3">
   <v-card>
      <v-card-title>
         <h1 class="title font-weight-bold grey--text darken-4 pl-2" style="color:#757575 !important">
            <v-icon class="pr-1">search</v-icon>
            <span>Search & Analyze</span>
         </h1>
      </v-card-title>

      <v-card-text>
         <bt-filter-wrapper-with-panel
            :show-test-cases="!isActualEndpoint"
            :bt-helpers="btHelpers"
            :closed-on-load="true"
            :fields="importHeaders"
            :filter-result="offers"
            :initial-filter="initialFilter"
            :is-admin="jwt.pa"
            :max="4"
            :preselected-fields="selectedHeaders"
            :should-init="shouldInitFilterDefiner"
            :std-field-values="stdFieldValues"
            v-model="filter"
            @filter-change="filterChanged"
         ></bt-filter-wrapper-with-panel>
      </v-card-text>

      <v-card-text v-show="!showGroupbyTable" class="pt-0 pb-2">
         <!-- <v-data-table v-show="showGroupbyTable"
            dense hide-default-footer
            class="elevation-1 mb-5"
            :footer-props="{
               itemsPerPageOptions:[31],
               showFirstLastPage: false
            }"
            :headers="offerHeaders"
            :item-key="itemKey"
            :items="offers"
            :items-per-page="31"
            :loading="loadingOffers"
            :loading-text="$t('loading-text')"
            :no-data-text="$t('no-data-text', { value: 'offers' })"
            :no-results-text="$t('no-results-text', { value: 'offers' })"
            :search="search"
         >
            <template v-slot:[`item._id`]="{item}">
               {{ getIdValue(item._id) }}
            </template>
            <template v-slot:[`item.Average`]="{item}">
               {{ formatNumber(item.Average, 2) }}
            </template>
            <template v-slot:[`item.Count`]="{item}">
               {{ formatNumber(item.Count, 0) }}
            </template>
            <template v-slot:[`item.Maximum`]="{item}">
               {{ formatNumber(item.Maximum, 0) }}
            </template>
            <template v-slot:[`item.Minimum`]="{item}">
               {{ formatNumber(item.Minimum, 0) }}
            </template>
            <template v-slot:[`item.Total`]="{item}">
               {{ formatNumber(item.Total, 0) }}
            </template>
         </v-data-table> -->

         <v-data-table dense show-expand single-expand
            class="elevation-1 mb-2"
            :footer-props="{
               itemsPerPageOptions:[5, 10, 20],
               showFirstLastPage: true
            }"
            :headers="offerHeaders"
            :hide-default-footer="offersCount <= 5"
            :item-key="itemKey"
            :items="offers"
            :items-per-page="5"
            :loading="loadingOffers"
            :loading-text="$t('loading-text')"
            :no-data-text="$t('no-data-text', { value: 'offers' })"
            :no-results-text="$t('no-results-text', { value: 'offers' })"
            :options.sync="options"
            :server-items-length="offersCount"
            :search="search"
            @update:expanded="offerExpanded"
         >
            <!-- <template v-slot:[`item.actions`]="{ item }">
               <v-icon small
                  class="mr-2"
                  @click="editOffer(item)"
               >edit</v-icon>
               <v-icon small
                  @click="deleteOffer(item)"
               >delete</v-icon>
            </template> -->
            <template v-slot:expanded-item="{ item }">
               <td v-for="(colspan, i) in colspans" :key="i"
                  dense
                  class="py-2" valign="top"
                  :colspan="colspan"
               >
                  <ul v-if="item.details">
                     <li v-for="(detail, j) in item.details[i]" :key="`${i}_${j}`">
                        <span class="expanded-header">{{detail.key}}: </span>
                        <span v-if="detail.key==='events'"
                           class="expanded-content"
                        >
                           <!-- <v-btn link height="27px" @click="eventsClicked(detail.value)">{{detail.value.length}}</v-btn> -->
                           <v-btn text icon dense
                              :disabled="!detail.value.length"
                              @click="eventsClicked(detail.value)"
                           >{{detail.value.length}}
                              <v-icon v-if="detail.value.length">more_horiz</v-icon>
                           </v-btn>
                        </span>
                        <span v-else
                           class="expanded-content"
                        >{{detail.value}}
                        </span>
                     </li>
                     <li v-if="i === colspans.length - 1">
                        <span class="expanded-header"># of Fields: </span>
                        <span class="expanded-content">{{item.details[0].length+item.details[1].length+item.details[2].length}}</span>
                     </li>
                  </ul>
               </td>
            </template>
         </v-data-table>

         <v-layout>
            <v-row>
               <v-col cols="2" class="py-0">
                  <v-btn v-if="$store.getters.user.policies.includes(`contact-offers-delete`) && offersCount"
                     small
                     color="error"
                     :loading="loadingDeleteBtn"
                     @click="deleteResultsClicked"
                  >
                     <v-icon left>delete</v-icon>
                     Delete Results
                  </v-btn>
               </v-col>
               <v-col v-if="isAnotherDelete"
                  class="pt-1 pb-0 error--text"
               >
                  A delete request is already in progress. Please try again after a while.
               </v-col>
            </v-row>
         </v-layout>
      </v-card-text>

      <v-dialog no-click-animation persistent scrollable
         max-width="1280px"
         v-model="dialogEvents"
      >
         <v-card flat tile>
            <v-card-title class="title grey--text darken-4 font-weight-bold pb-4">Events:</v-card-title>
            <v-card-text class="px-4 py-2">
               <v-data-table dense show-expand single-expand
                  class="elevation-1 mb-2"
                  :expanded.sync="expanded"
                  :footer-props="{
                     itemsPerPageOptions:[5, 10, 20],
                     showFirstLastPage: true
                  }"
                  :headers="eventHeaders"
                  :hide-default-footer="events.length < 11"
                  item-key="__csDocumentsExtras.id"
                  :items="events"
                  :items-per-page="10"
                  :loading="loadingEvents"
                  :loading-text="$t('loading-text')"
                  :no-data-text="$t('no-data-text', { value: 'events' })"
                  :no-results-text="$t('no-results-text', { value: 'events' })"
                  :search="search"
                  @update:expanded="eventExpanded"
               >
                  <template v-slot:expanded-item="{ item }">
                     <!-- <td dense class="py-2" valign="top">&nbsp;</td> -->
                     <td dense
                        class="py-2" valign="top"
                        :colspan="eventHeaders.length"
                     >
                        <ul v-if="item.__csDocumentsExtras.details && item.__csDocumentsExtras.details.length">
                           <li v-for="(detail, j) in item.__csDocumentsExtras.details" :key="j">
                              <span class="expanded-header">{{detail.key}}: </span>
                              <span class="expanded-content">{{detail.value}}</span>
                           </li>
                        </ul>
                        <ul v-else>
                           <li>
                              <span class="expanded-header"></span>
                              <span class="expanded-content">No details are available</span>
                           </li>
                        </ul>
                     </td>
                  </template>
               </v-data-table>
            </v-card-text>
            <v-card-actions class="py-0 pr-3">
               <div class="flex-grow-1"></div>
               <v-btn text
                  class="px-0"
                  color="blue darken-1"
                  @click="closeDialogEvents"
               >Close</v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

      <v-card-text v-if="showChart" class="pt-0 pb-3">
         <bt-chart
            :show-test-cases="!isActualEndpoint"
            :can-edit-chart="true"
            :can-edit-filter="true"
            :data="offers"
            :debug="debug"
            :fields="importHeaders"
            :flat="false"
            :has-pagina-table="false"
            :is-admin="jwt.pa"
            :max="4"
            :preselected-fields="selectedHeaders"
            :should-init="shouldInitFilterDefiner"
            :std-field-values="stdFieldValues"
            v-model="chart"
            @filter-change="filterChanged"
         ></bt-chart>
      </v-card-text>

      <v-dialog no-click-animation persistent scrollable
         max-width="480px"
         v-model="dialogDelete"
      >
         <v-card flat tile :loading="isDeleteInProcess">
            <v-card-title class="title grey--text darken-4 font-weight-bold pb-4">Deleting Results</v-card-title>
            <v-card-text class="px-5 pt-2 pb-1">
               <v-icon>warning_amber</v-icon> To delete {{new Intl.NumberFormat().format(offersCount)}} records, type <span class="font-weight-bold">{{offersCount}}</span> in the following box:
               <v-text-field dense outlined hide-details
                  ref="numberOfOffers"
                  class="py-2"
                  v-model="numberOfOffers"
               ></v-text-field>
               <div v-if="isDeleteInProcess"
                  class="error--text font-weight-bold"
               >
                  <v-progress-circular indeterminate
                     color="red"
                     :size="20"
                     :width="2"
                  ></v-progress-circular>
                  Please wait while your request is being processed: {{deleteElapsedTime}}
               </div>
            </v-card-text>
            <v-card-actions class="pt-0 pb-2 pr-3">
               <div class="flex-grow-1"></div>
               <v-btn text
                  class="px-0"
                  color="blue darken-1"
                  :disabled="isDeleteInProcess"
                  @click="cancelDialogDelete"
               >Cancel</v-btn>
               <v-btn text
                  class="px-0"
                  color="blue darken-1"
                  :disabled="numberOfOffers != offersCount || isDeleteInProcess"
                  @click="submitDialogDelete"
               >Submit</v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>
   </v-card>
</v-container>
</template>

<script>
import BtFilterWrapperWithPanel from './BtFilterWrapperWithPanel.vue';
import BtChart from './BtChart.vue';
import { APIService } from '../services/cs-api-service.js';
import { isIncluded, getAllBehavioralFields } from '../mixins/bt-mixin.js';
import { BtHelpers } from '../services/bt-helpers.js';
import { differenceInHours, differenceInMinutes, differenceInSeconds } from "date-fns";

const NAME = "CsDocuments";
const DAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export default {
   name: NAME,

   components: {
      BtFilterWrapperWithPanel,
      BtChart,
   },

   props: {
      debug: {
         type: Boolean,
         default: false
      },
      isActualEndpoint: {
         type: Boolean,
         default: true
      }
   },

   data() {
      return {
         panelFilter: [],  //[0]
         limit: 5,
         rules: {
            required: value => !!value || "Value is required!",
         },
         jwt: {},
         apiService: null,
         btHelpers: null,
         loadingOffers: true, //false,
         importHeaders: [], //['firstname', 'lastname', 'age', 'seed', 'car', 'country', 'id']
         offers: [],
         search: "",
         offerHeaders: [],
         selectedHeaders: [],
         isOfferHeadersNeeded: true,
         shouldInitFilterDefiner: false,
         colspans:[],
         offersCount: 0,
         options: {
               // page: number,
               // itemsPerPage: number,
               // sortBy: string[],
               // sortDesc: boolean[],
               // groupBy: string[],
               // groupDesc: boolean[],
               // multiSort: boolean,
               // mustSort: boolean
         },
         lastImport: null,
         stdFieldValues: {},
         chart: {
            title: '',
            type: 'ColumnChart',
            options: {},
            filter: {}
         },
         itemKey: '_id',
         filter: {},
         behFields: null,
         behFieldsForGroupby: null,
         dialogEvents: false,
         loadingEvents: false,
         eventHeaders: [],
         events: [],
         expanded: [],
         loadingDeleteBtn: false,
         isAnotherDelete: false,
         dialogDelete: false,
         numberOfOffers: '',
         isDeleteInProcess: false,
         deleteElapsedTime: '',
         initialFilter: {}
      }
   },

   computed: {
      token() {
         return this.$store.getters.token;
      },

      showGroupbyTable() {
         // return this.filter.columns && this.filter.columns.length === 0;
         return this.filter.standard && this.filter.standard.length > 1;
      },

      showChart() {
         //no chart for distinct query
         // alert('showGroupbyTable=' + this.showGroupbyTable +
         //    '\noffers=' + this.offers);
         // if (this.offers && this.offers.length > 0)
         //    alert('showGroupbyTable=' + this.showGroupbyTable +
         //       '\noffers=' + this.offers + '\nlen=' + this.offers.length +
         //       '\nkeys=' + JSON.stringify(Object.keys(this.offers[0])));
         return this.showGroupbyTable && 
            this.offers && 
            this.offers.length > 0 && 
            Object.keys(this.offers[0]).length > 2;   //2 is because of the index key
      },
   },

   watch: {
      token() {
         this.init();
      },

      options: {
         handler (val) {
            // alert('in watch: options=' + JSON.stringify(val));
            if (val.sortBy.length > 0) {
               const sort = {};
               sort[val.sortBy[0]] = val.sortDesc[0] ? -1 : 1;
               this.filter.sort = sort;
            }
            this.getOffers();
         }
      }
   },

   methods: {
      log(msg) {
         if (this.debug) {
            console.log(`-----${NAME} B1.25 says => ${msg}`);
         }
      },

      logout() {
         this.$router.push('/');
      },

      async init() {
         // alert('in init(): token=' + this.token);
         this.importHeaders = [];

         if (this.token) {
            this.loadingOffers = true;
            const JWT = JSON.parse(atob(this.token.split('.')[1]));
            this.jwt = {
               aid: JWT.aid,
               paid: JWT.paid,
               pa: JWT.pa,
               pu: JWT.pu
            };
            this.log('in CsDocuments.init(): jwt=' + JSON.stringify(this.jwt));
            this.apiService = new APIService(this.jwt, this.token, this.debug, this.isActualEndpoint);
            this.btHelpers = new BtHelpers(this.token, this.isActualEndpoint, this.debug);
            this.filter = this.btHelpers.getInitialFilter();   //columns will be added later on
            this.stdFieldValues = await this.btHelpers.getFieldValues(this.filter);
            this.importHeaders = await this.btHelpers.getImportHeaders(this.filter, true);

            if (this.importHeaders.length > 0) {
               // this.importHeaders.push({ text: 'Import', value: 'importId', internalField: true, type: 'string' });
               this.selectedHeaders = await this.btHelpers.getSelectedHeaders(this.importHeaders, 7);
            } else {
               this.selectedHeaders = [];
               alert("Sorry, something went wrong that we couldn't obtain your import headers!");
            }

            this.filter.columns = [...this.selectedHeaders];
            //B1.22
            this.filter.standard[0].$match.importId = this.stdFieldValues.importId[0].value;
            this.initialFilter.standard = ['importId'];
            await this.filterChanged(this.filter);
            this.shouldInitFilterDefiner = true;
            this.loadingOffers = false;
            // alert('in init(): importHeaders=' + JSON.stringify(this.importHeaders));
         } else
            this.jwt = {};
      },

      async filterChanged(filter) {
         this.log('in filterChanged(): ' + JSON.stringify(filter));
         this.filter = filter;
         if (this.importHeaders.length > 0) {
            // alert('in filterChanged(): options=' + JSON.stringify(this.options));
            this.offersCount = await this.getOffersCount();
            // this.options.page = 1;
            this.isOfferHeadersNeeded = true;
            this.selectedHeaders = [...filter.columns];
            // await this.getOffers();

            const len = filter.columns.length + 1;
            this.colspans = [];
            this.colspans.push(Math.ceil(len / 3));
            this.colspans.push(Math.ceil((len - this.colspans[0]) / 2));
            this.colspans.push(len - this.colspans[0] - this.colspans[1]);
            // alert('len='+this.colspans.join(','));

            const currOptions = JSON.stringify(this.options);
            const newOptions = JSON.parse(currOptions);
            newOptions.page = 1;
            if (filter.sort) {
               // this.isDataCurrent = true;
               const key = Object.keys(filter.sort)[0];
               newOptions.sortBy = [key];
               newOptions.sortDesc = [filter.sort[key] === -1];
               // alert('options=' + JSON.stringify(this.options))
            }
            if (JSON.stringify(newOptions) === currOptions)
               await this.getOffers();
            else
               this.options = newOptions;
         }
         // alert('filter.standard.length=' + filter.standard.length +
         //    '\nfilter=' + JSON.stringify(filter));

         // was modified in B1.1
         // if (filter.standard.length > 1) {
         //    this.chart = {
         //       title: '',
         //       type: 'ColumnChart',
         //       options: {},
         //       filter: filter
         //    };
         // } else {
         //    this.chart = {
         //       title: '',
         //       type: '',
         //       options: {},
         //       filter: {}
         //    };
         // }
         this.chart.filter = filter;
      },

      async getOffersCount() {
         let result = await this.apiService.getOffersCount(this.filter);
         if (result.logout)
            this.logout();
         return result.message ? 0 : result.data;
      },

      async getOffers() {
         if (Object.keys(this.filter).length === 0 || !this.filter.columns || this.filter.columns.length === 0) return;

         // alert('in getOffers()...\n' + JSON.stringify(this.filter));
         this.loadingOffers = true;
         // const { sortBy, sortDesc, page, itemsPerPage } = this.options
         // let result = await this.apiService.getOffers(this.jwt.aid, this.filter.standard, this.filter.columns, this.options.page, this.options.itemsPerPage);
         let result = await this.apiService.getOffers(this.filter, this.options.page, this.options.itemsPerPage);
         if (result.logout)
            this.logout();
         else if (result.message)
            this.offers = [];
         else if (result.data.length) {
            result.data.forEach(offer => {
               for (const key in offer) {
                  const val = offer[key].toString().toLowerCase();
                  if (val === 'true' || val === 'false')
                     offer[key] = offer[key].toString();
               }
            });

            if (this.isOfferHeadersNeeded) {
               this.offerHeaders = [];
               const group = this.filter.standard.filter(f => f.$group);
               if (group.length === 1) {
                  const _id = group[0].$group._id;
                  let id, idFieldText, idFieldType;
                  let idFieldPostfix;
                  if (typeof _id === 'object') {
                     Object.keys(_id).forEach(key => {
                        idFieldPostfix = ' / ';
                        const val = _id[key];
                        // alert('key=' + key + ', val=' + JSON.stringify(val));
                        if (typeof val === 'object') {
                           id = val['$' + key].replace('$events.', '').replace('$', '');
                           // alert('if val object: id=' + id);
                           let idField = this.importHeaders.find(f => f.value === id);
                           if (!idField)
                              idField = this.behFieldsForGroupby.find(f => f.value === id);

                           idFieldText = idField.text;
                           idFieldType = idField.type;
                        } else {
                           // id = _id[key];
                           // alert('else val object: id=' + id);
                           idFieldText = key;
                           idFieldType = '';
                        }

                        switch (key) {
                           case 'year':
                              idFieldPostfix += 'Yearly'
                              break;
                           case 'month':
                              idFieldPostfix += 'Monthly'
                              break;
                           case 'dayOfMonth':
                              idFieldPostfix += 'Daily'
                              break;
                           case 'hour':
                              idFieldPostfix += 'Hourly'
                              break;
                           case 'dayOfWeek':
                              idFieldPostfix += 'Day of the Week'
                              break;
                           default:
                              idFieldPostfix = '';
                              break;
                        }

                        this.offerHeaders.push({ 
                           text: idFieldText + idFieldPostfix, 
                           value: '_id' + (idFieldType === 'date' ? '' : '.' + idFieldText)
                        });
                     });
                  } else {
                     // id = _id.replace('$', '');
                     // alert('_id=' + _id + ', id=' + id);
                     idFieldPostfix = '';
                  }

                  for (let i = 1; i < Object.keys(result.data[0]).length; i++) {
                     const element = Object.keys(result.data[0])[i];
                     this.offerHeaders.push({ text: element, value: element });
                  }
               } else {
                  this.offerHeaders = this.importHeaders.filter(header => isIncluded(this.selectedHeaders, header.value, true));
                  //this.offerHeaders.push({ text: 'Actions', value: 'actions', align: 'right', sortable: false, width: "10%" });
               }

               this.offerHeaders.forEach(header => {
                  header.sortable = header.isIndexed;
               });

               this.isOfferHeadersNeeded = false;
               // alert('in getOffers(): offerHeaders=' + JSON.stringify(this.offerHeaders));
            }

            if (this.filter.standard.length > 1) {
               this.itemKey = 'index';
               result.data.forEach((d, i) => {
                  d.index = i;
               });
               this.offers = [...result.data];
            } else {
               this.itemKey = '_id';
               this.offers = result.data;
            }
         }

         this.loadingOffers = false;
         this.log('in getOffers(): offers=' + JSON.stringify(this.offers));
      },

      async offerExpanded(offer) {
         // alert('in offerExpanded(): offer=' + JSON.stringify(offer));
         if (offer.length === 0 || offer[0].details) return;

         this.loadingOffers = true;
         let result = await this.apiService.getOffer(offer[0]._id);
         if (result.logout)
            this.logout();
         else if (!result.message) {
            offer[0].details = [[], [], []];
            let seq= 0;
            for (const key in result.data) {
               offer[0].details[seq++].push({ key: key, value: result.data[key] });
               if (seq === 3) seq = 0;
            }
         }
         this.loadingOffers = false;
         this.log('in offerExpanded(): offer=' + JSON.stringify(offer[0].details));
      },

      getIdValue(value) {
         // alert('value=' + JSON.stringify(value) + '\n' + Object.keys(value)[0]);
         if (typeof value === 'object') {
            const key = Object.keys(value)[0];
            if (key === 'dayOfWeek')
               return DAYS[value[key] - 1];
            else if (key === 'month')
               return MONTHS[value[key] - 1];
            else
               return value[key];
         } else
            return value;
      },

      formatNumber(number, maxFractionDigits) {
         return new Intl.NumberFormat('en-US', 
            { 
               maximumFractionDigits: maxFractionDigits
            }).format(number);
      },

      eventsClicked(events) {
         // alert('in eventsClicked(): events=' + JSON.stringify(events));
         this.dialogEvents = true;
         this.loadingEvents = true;
         const headers = [];
         const mainHeaders = new Set();
         const subHeaders = new Set();

         events.forEach((event, i) => {
            Object.keys(event).forEach(key => {
               if (this.behFields.find(f => f.value === key.toString()))
                  mainHeaders.add(key);
               else if (key.toString() != '__csDocumentsExtras')
                  subHeaders.add(key);
            });
            event.__csDocumentsExtras = { id: `${event.event_code}_${event.event_date}_${i}` };
         });

         // alert('mainHeaders.size=' + mainHeaders.size + ', subHeaders.size=' + subHeaders.size);

         mainHeaders.forEach(h => {
            /* B1.24
            let text;
            switch (h) {
               case 'app_code':
                  text = 'App Code';
                  break;
               case 'event_code':
                  text = 'Event Code';
                  break;
               case 'event_date':
                  text = 'Event Date';
                  break;
               case 'is_trigger':
                  text = 'Is Trigger';
                  break;
               case 'os':
                  text = 'Operating System';
                  break;
               case 'browser':
                  text = 'Browser';
                  break;
               case 'ip':
                  text = 'IP';
                  break;
               case 'pdid':
                  text = 'Process Definition ID';
                  break;
               default:
                  break;
            }

            if (text)
               headers.push({ text: text, value: h, align: 'left', sortable: true });
            */

            const behField = this.behFields.find(f => f.value === h);
            if (behField)
               headers.push({ text: behField.text, value: h, align: 'left', sortable: true });
         });

         this.events = [...events];
         this.eventHeaders = [...headers];
         this.eventDetailHeaders = Array.from(subHeaders);
         this.loadingEvents = false;
      },

      eventExpanded(event) {
         // alert('in eventExpanded(): event=' + JSON.stringify(event));
         if (event.length === 0) return;

         const e = event[0];
         // e.details = [];
         e.__csDocumentsExtras.details = [];
         this.eventDetailHeaders.forEach(h => {
            if (e[h])
               e.__csDocumentsExtras.details.push({ key: h, value: e[h] });
         });
         // alert('in eventExpanded(): e=' + JSON.stringify(e));
      },

      closeDialogEvents() {
         this.expanded = [];
         this.dialogEvents = false;
      },

      editOffer() {},
      deleteOffer() {},

      async deleteResultsClicked() {
         this.loadingDeleteBtn = true;
         this.isAnotherDelete = false;
         const filter = this.btHelpers.getInitialFilter();
         filter.standard[0].$match.status = 'processing';
         let result = await this.apiService.getDeletesCount(filter);
         this.loadingDeleteBtn = false;
         if (result.logout)
            this.logout();
         else if (!result.message) {
            if (result.data)
               this.isAnotherDelete = true;
            else {
               this.numberOfOffers = '';
               this.dialogDelete = true;
               setTimeout(() => {
                  this.$refs.numberOfOffers.focus();
               }, 10);
            }
         }
      },

      cancelDialogDelete() {
         this.dialogDelete = false;
      },

      async submitDialogDelete() {
         this.isDeleteInProcess = true;
         const dateStarted = new Date();
         const setIntervalDeletes = setInterval(() => {
            if (this.isDeleteInProcess) {
               // let et = this.deleteElapsedTime++;
               const DateEnded = new Date();
               const h = differenceInHours(DateEnded, dateStarted);
               const min = differenceInMinutes(DateEnded, dateStarted);
               const m = min - h * 60;
               const s = differenceInSeconds(DateEnded, dateStarted) - h * 3600 - m * 60;
               this.deleteElapsedTime = '';
               if (h) this.deleteElapsedTime = h + 'h ';
               if (min) this.deleteElapsedTime += m + 'm ';
               this.deleteElapsedTime += s + 's';
            }
            else {
               clearInterval(setIntervalDeletes);
               // this.deleteElapsedTime = 0;
            }
         }, 1000);
         let result = await this.apiService.deleteOffers(this.filter, this.numberOfOffers);
         this.isDeleteInProcess = false;
         if (result.logout)
            this.logout();
         else if (!result.message) {
            this.$emit('snackbar-event', `'${result.data}' records were deleted.`);
            this.cancelDialogDelete();
            this.filterChanged(this.filter);
         }
      }
   },

   created() {
      this.behFields = getAllBehavioralFields();
      this.behFieldsForGroupby = this.behFields.filter(f => f.value != 'ip' && f.value != 'pdid');
      this.init();
   }
}
</script>

<style scoped>
.expanded-header {
   font-style: italic;
   font-weight: bold;
}
</style>
